/*
 * @description : 项目的入口文件
 * @author : maskim
 * @date : 2021-07-28 14:52:58
 * @lastTime : 2022-06-14 11:48:38
 * @LastAuthor : Do not edit
 * @文件路径 : /ces项目模板/src/index.js
 */
// 习惯采用less，引入需要用到less代码入口。注意不支持bg自动计算尺寸、不支持动态数学计算
import "./less/index.less";
import FirstLoadingUI from "./loading/FirstLoadingUI"; // 首屏加载界面，如果是animate 的 pixi，那这个dom使用与pixi一致的画面可以减少白屏情况
import { loader } from "ces";
import { SiteModelBase, WeChatShareModel } from "ces-mini-h5";

//  引入 package.json
const pkg = require("../package.json");
// 设置缓存版本。js逻辑代码、资源加载等都会跟随这个缓存版本号来
const { Loader } = loader;
Loader.cacheVersion = pkg.version;

/**
 * 站点模块
 *
 * @author maksim
 * @date 06/08/2021/  11:47:01
 * @class CagoeSiteModel
 * @extends {SiteModelBase}
 */
class CagoeSiteModel extends SiteModelBase {
	constructor() {
		super();

        // 是否正式环境
		this.isOnline = location.origin.includes("mcenter.wx.lining");

		// 记录項目文件夾路徑
		this.projectDirectory = "../" + pkg.projectFolder + "/";
		this.path = this.projectDirectory;

		// 加载缓存版本号
		this.LoaderCacheVersion = Loader.cacheVersion;

		// 初始化分享,这里写是为了可以更早处理分享模块构建
		// this.initializeShare();

		// 初始化模块
		this.initialize();
	}

	/**
	 * 初始化
	 *
	 * @author maksim
	 * @date 04/08/2021/  19:16:18
	 * @memberof CagoeSiteModel
	 */
	async initialize() {
		// TODO: 设置默认的第一个页面。确保有这个页面，并且资源加载
		this.setDefaultPage("GetCouponPage");

		// 初始化loading界面【推荐loading采用dom的方式】
		this.initializeLoadPanel();
		this.showProgress(5);

		// 载入站点入口
		await this.loadSiteAppEntry();

		// 显示进度
		this.showProgress(20);

		// 显示场景dom元素根容器，为了避免显示失败情况下处理
		this.siteScene.show();
	}

	/**
	 * loading界面
	 *
	 * @author maksim
	 * @date 06/08/2021/  11:47:16
	 * @memberof CagoeSiteModel
	 */
	initializeLoadPanel() {
		this.siteScene.show(); // 显示场景dom元素根容器
		this.mainLoadUIBox = $("#load-main-panel");
		this.mainLoadUIBox.show();

		// 构建loadingUI 对象
		this.firstLoadingUI = new FirstLoadingUI(this, {
			color: "#e32035", // loading颜色
			background: "#f5f5f5", // loading背景色
		});
	}

	/**
	 * 程序入口js加载
	 *
	 * @author maksim
	 * @date 06/08/2021/  11:47:24
	 * @returns {*}
	 * @memberof CagoeSiteModel
	 */
	loadSiteAppEntry() {
		return import(/* webpackChunkName: "site_app_entry" */ "./site_app_entry.js");
	}

	/**
	 * 进度控制
	 *
	 * @author maksim
	 * @date 06/08/2021/  11:47:34
	 * @param {*} ps
	 * @memberof CagoeSiteModel
	 */
	showProgress(ps) {
		this.firstLoadingUI.setProgress(ps);
	}
	/**
	 *  进度隐藏
	 *
	 * @author maksim
	 * @date 06/08/2021/  11:47:39
	 * @memberof CagoeSiteModel
	 */
	hideProgress() {
		this.firstLoadingUI.hide();
	}

	/**
	 *  初始化分享模块
	 *
	 * @author maksim
	 * @date 06/08/2021/  12:06:52
	 * @memberof APPModel
	 */
	initializeShare(setting) {
        // 测试环境分享接口地址
		const _uatApiUrl = "https://open-wxqas.lining.com/AuthorizerJsApiWXConfig?AuthorizerAppID=wx87823c7cd569116f";
		// 正式环境分享接口地址
		const _onLineApiUrl = "https://open.wx.lining.com/AuthorizerJsApiWXConfig?AuthorizerAppID=wx1b4bee875448c4ac";
		let _shareModel = new WeChatShareModel({
			title: setting.title || '速速提供分享标题',
			info: setting.info || '速速提供分享文案',
			timelineInfo: setting.timelineInfo || '速速提供分享文案',
			shareUrl: setting.shareUrl || location.href,
			// workUrl: location.href,
			imageUrl: setting.imageUrl || `${this.projectDirectory}/images/ShareImg.jpg`,
			wxJsUrl: setting.wxJsUrl || `${this.projectDirectory}/js/cagoeShare.js`,
			apiUrl: this.isOnline ? _onLineApiUrl : _uatApiUrl,
			shareCallBack: setting.shareCallBack || (()=>{}),
		});
		_shareModel.on("shareAPIEnd", (e) => {
			console.log("shareAPIEnd", e);
		});
		_shareModel.on("shareAPIError", (e) => {
			console.log("shareAPIError");
		});
		_shareModel.on("setShareEnd", () => {
			console.log("setShareEnd");
		});
		// 设置默认分享
		_shareModel.defaultWeiShare();
		this.shareModel = _shareModel;
	}
}

window.SiteModel = new CagoeSiteModel();
